import { useCallback, useEffect, useState } from 'react';
import { Bus, UseBusesArgs, UseBusesResult } from '../types/busTypes';
import { fetchBusesForSchool } from '../utils/utils';

const useBuses = ({ schoolId, onError }: UseBusesArgs): UseBusesResult => {
  const [buses, setBuses] = useState<Bus[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!schoolId) return;
    try {
      setLoading(true);
      const data = await fetchBusesForSchool(schoolId);
      setBuses(
        data
          .filter((bus) => bus.id || bus._id)
          .map((bus) => ({
            ...bus,
            id: bus.id || bus._id?.toString()
          }))
      );
    } catch (e) {
      onError && onError(e);
    } finally {
      setLoading(false);
    }
  }, [schoolId, onError]);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, []);

  return { buses, loading, refresh, setBuses };
};

export default useBuses;
